export const ResumptionRequestsPaths = {
  MANAGE_REQUEST_RESUMPTION_REQUESTS: 'resumption-requests',
  MANAGE_REQUEST_CREATE_RESUMPTION_REQUEST: 'create',
  MANAGE_REQUEST_EDIT_RESUMPTION_REQUEST: 'edit/:requestId',
};
